import { supabase } from './supabase'

export type AuditAction =
  | 'resource.create'
  | 'resource.update'
  | 'resource.delete'
  | 'resource.review'
  | 'team.create'
  | 'team.update'
  | 'team.delete'
  | 'team_member.add'
  | 'team_member.update'
  | 'team_member.remove'

interface AuditLogParams {
  action: AuditAction
  resourceType: string
  resourceId: string
  oldValue?: Record<string, unknown> | null
  newValue?: Record<string, unknown> | null
}

export async function writeAuditLog(params: AuditLogParams): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser()

  await supabase.from('audit_logs').insert({
    user_id: user?.id || null,
    action: params.action,
    resource_type: params.resourceType,
    resource_id: params.resourceId,
    old_value: params.oldValue || null,
    new_value: params.newValue || null,
  })
}
